<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span v-if="$route.meta.rtlActive">
          {{ rtlTitle }}
          <b class="caret"></b>
        </span>
        <span v-else >
          {{ title.name }} <br> 
          <span  style="font-size: 80%; 
           display: inline-block;
    width: 180px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;">
            {{ title.role_name.name_string }}
          </span>
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <a @click="goToProfile">
                  <span class="sidebar-mini">MP</span>
                  <span class="sidebar-normal">My Profile</span>
                </a>
              </li>
              
              <li>
                <a @click="logout">
                  <span class="sidebar-mini">L</span>
                  <span class="sidebar-normal">Logout</span>
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
export default {
props: ['title'],
  data() {
    return {
      isClosed: true,
      //title: 'Profile',
      rtlTitle: "",
      avatar: require("@/assets/images/charged_logo.png")
    };
  },
 
  // async created() {
  //   this.$store.watch(() => this.$store.getters["profile/me"], (me) => {
  //     this.title = me.name
  //   })
  //   await this.$store.dispatch("profile/me")
  // },

  methods: {
    clicked: function(e) {
      e.preventDefault();
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed;
    },
    goToProfile() {
      this.routePush("User Profile")
    },
   

    routePush(name_route){
      if(this.$route.name !== name_route){
        this.$router.push({name: name_route})
      }
    },
    logout() {
      this.$store.dispatch("profile/clear_me")
      this.$store.dispatch("logout");
    },
    
  }
}
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
